<template>
  <span :class="state">
    <component :is="icon" />
  </span>
</template>

<script>
import CheckboxChecked from './CheckboxChecked.vue'
import CheckboxUnchecked from './CheckboxUnchecked.vue'
import CheckboxIntermediate from './CheckboxIntermediate.vue'

export default {
  name: 'checkbox',
  components: { CheckboxChecked, CheckboxUnchecked, CheckboxIntermediate },
  props: {
    state: String,
  },
  computed: {
    icon() {
      switch (this.state) {
        case 'checked':
          return CheckboxChecked
        case 'none':
          return CheckboxUnchecked
      }
      return CheckboxIntermediate
    },
  },
}
</script>
